export const Caesura = () => '\u2009\u2014\u2009';
